export function isValidDate(value: string) {
  const d = new Date(value);
  return !isNaN(d.getTime());
}

export function parseQuizDate(dateStr: string) {
  const [day, monthName, year] = dateStr.split("-");

  const monthMap: Record<string, number> = {
    January: 0,
    February: 1,
    March: 2,
    April: 3,
    May: 4,
    June: 5,
    July: 6,
    August: 7,
    September: 8,
    October: 9,
    November: 10,
    December: 11,
  };

  const month = monthMap[monthName];

  if (month === undefined) return null;

  return new Date(Date.UTC(Number(year), month, Number(day)));
}

export function getISTDateString(dateInput?: Date | string) {
  const date = dateInput ? new Date(dateInput) : new Date();

  if (isNaN(date.getTime())) {
    throw new Error("Invalid date");
  }

  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

export function isTimeOver(endTime: string | Date) {
  const now = new Date();

  // Current IST time
  const nowIST = new Date(
    now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );

  // End time in IST
  const endIST = new Date(
    new Date(endTime).toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );

  const nowMinutes =
    nowIST.getHours() * 60 +
    nowIST.getMinutes() +
    nowIST.getSeconds() / 60;

  const endMinutes =
    endIST.getHours() * 60 +
    endIST.getMinutes() +
    endIST.getSeconds() / 60;

  return nowMinutes >= endMinutes;
}
